import * as React from "react";
type Props = {
  className?: string,
};
function SvgSnacksSmall({ className }: Props) {
  return (
    <svg
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-SnacksSmall"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9542 45.3148C33.9239 45.3148 53.4482 24.4197 43.6272 22.2826C33.8062 20.1456 46.2584 0.199951 34.2887 0.199951C27.7929 0.199951 25.2809 9.2959 5.54978 4.94883C1.23891 3.99875 -0.197703 12.0722 1.23891 25.3692C2.67604 38.6663 9.98451 45.3148 21.9542 45.3148Z"
        fill="#D6E4EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6205 4.09557C13.6237 3.99275 13.3586 6.16976 12.1775 6.62081C11.1445 7.01509 9.33491 5.82332 7.2616 7.81258C3.81995 11.1148 7.00993 15.7115 8.41135 16.9619C11.5647 19.7745 12.4963 19.6167 13.1534 19.6574C14.3362 19.6208 14.9571 18.3995 16.3979 17.7701C18.9044 16.813 21.9692 19.3892 21.9942 10.4474C21.9996 8.56895 21.0032 4.24577 16.6205 4.09557Z"
        fill="white"
      />
      <path d="M12.8467 13.575L13.4452 11.9622" stroke="currentColor" />
      <path
        d="M16.2849 12.3612L14.9385 11.2905"
        stroke="currentColor"
        strokeWidth={1.75}
      />
      <path
        d="M12.1774 6.62072C12.1774 6.62072 12.0629 3.26356 10.2529 2.33643"
        stroke="currentColor"
        strokeWidth={1.75}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6205 4.09557C13.6237 3.99275 13.3586 6.16976 12.1775 6.62081C11.1445 7.01509 9.33491 5.82332 7.2616 7.81258C3.81995 11.1148 7.00993 15.7115 8.41135 16.9619C11.5647 19.7745 12.4963 19.6167 13.1534 19.6574C14.3362 19.6208 14.9571 18.3995 16.3979 17.7701C18.9044 16.813 21.9692 19.3892 21.9942 10.4474C21.9996 8.56895 21.0032 4.24577 16.6205 4.09557Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgSnacksSmall;
